const layoutButtons = document.querySelectorAll(".layout-selector button");
const productGrid = document.querySelector("ul.product-grid");

layoutButtons.forEach(function (layoutBtn) {
  layoutBtn.addEventListener("click", function () {
    layoutButtons.forEach(function (btn) {
      btn.setAttribute("aria-pressed", "false");
    });
    if (!this.classList.contains("selected")) {
      this.classList.add("selected");
      this.setAttribute("aria-pressed", "true");
      if (this.classList.contains("select-list")) {
        productGrid.classList.add("list-layout");
        localStorage.setItem("layoutCollection", "list");
      } else {
        if (productGrid.classList.contains("list-layout")) {
          productGrid.classList.remove("list-layout");
          localStorage.setItem("layoutCollection", "grid");
        }
      }

      const next = this.nextElementSibling;
      const prev = this.previousElementSibling;

      if (next && next.classList.contains("selected")) {
        next.classList.remove("selected");
      } else if (prev && prev.classList.contains("selected")) {
        prev.classList.remove("selected");
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", (event) => {
  if (localStorage.getItem("layoutCollection") === "list") {
    productGrid.classList.add("list-layout");
    document
      .querySelector(".layout-selector .select-list")
      .classList.add("selected");
    document
      .querySelector(".layout-selector .select-list").setAttribute("aria-pressed", "true");
    document
      .querySelector(".layout-selector .select-grid")
      .classList.remove("selected");
    document
      .querySelector(".layout-selector .select-grid")
      .setAttribute("aria-pressed", "false");
  }

  const products = document.querySelectorAll(
    "ul.product-grid .product-card-wrapper"
  );

  products.forEach(function (product) {
    const quickOrderList = product.querySelector("quick-order-list");
    const variants = quickOrderList.querySelectorAll(".variant-item");

    if (variants.length > 1) {
      variants[0].classList.add("visible");

      const parent = variants[0].parentElement;
      const button = document.createElement("button");
      button.textContent =
        "Näytä " + (variants.length - 1) + " muuta sidosasua";
      parent.after(button);

      const hiddenVariants = Array.from(variants).slice(1);
      console.log(hiddenVariants);
      hiddenVariants.forEach(function (variant) {
        variant.classList.add("hidden");
      });

      button.addEventListener("click", function () {
        console.log(this.textContent);
        if (this.textContent === "Piilota sidosasut") {
          this.textContent =
            "Näytä " + (variants.length - 1) + " muuta sidosasua";
        } else {
          this.textContent = "Piilota sidosasut";
        }
        hiddenVariants.forEach(function (item) {
          item.classList.toggle("hidden");
        });
      });
    }
  });
});
